import Paul from "./images/paul.jpg";
import William from "./images/william.png";
import Sorin from "./images/sorin.png";
import Olu from "./images/olu.jpg";
import Stephano from "./images/stefano.jpeg";
import Til from "./images/til.jpeg";
import Matson from "./images/matson.jpg";
import Julia from "./images/julia.png";
import Zoe from "./images/zoe.jpeg";
import Nanda from "./images/nanda.jpeg";

// Icons
import { FaLinkedinIn } from "react-icons/fa";
import { AiFillGithub } from "react-icons/ai";

// Methods Images
import Benchmark from "./images/benchmarksImage.png";
import Scope from "./images/scopeImage.png";

export const Team_Members = [
  {
    id: 1,
    name: "Paul Rosler",
    title: "Founder & CEO",
    about:
      "Paul came up with the idea behind Oxari. He graduated with the Banking & Finance Master at Utrecht University. He also studied Sustainable Economics at the University of Oldenberg and worked for the sustainable bank Triodos. Besides his professional life, Paul plays classical guitar, travels, and hikes in the mountains of Mexico, where he currently lives.",
    image: Paul,
    socials: [
      {
        id: 1,
        linkedIn_link: "#",
        image: <FaLinkedinIn className="linkedIn" />,
      },
      {
        id: 2,
        github_link: "#",
        image: <AiFillGithub className="github" />,
      },
    ],
  },
  {
    id: 2,
    name: "William Vuijk",
    title: "Founder & CFO",
    about:
      "William handles the financial and law issues at Oxari. He is part of the Buisiness Development and Entrepreneurship Master at Utrecht University. He is the founder of Guillame Ties and also works for a sustainable crowdfunding platform. In his free time, William skis, reads management books, and makes new additions to his wine collection.",
    image: William,
    socials: [
      {
        id: 1,
        linkedIn_link: "#",
        image: <FaLinkedinIn className="linkedIn" />,
      },
    ],
  },
  {
    id: 3,
    name: "Sorin Dragan",
    title: "Founder & CTO",
    about:
      "Sorin is a versatile Software Engineer with a M.Sc. Degree in Artificial Intelligence awarded by Utrecht University. There, he completed his thesis in partnership with CWI, the research institute where both Python and Dijkstra’s algorithm were invented, and served as a teaching assistant for two Master level courses. He also holds a B.Eng. Degree in Computer Science from the Politehnica University of Bucharest. Sorin previously worked as a Machine Learning Developer as well as a Software Developer Engineer for AWS, where he was directly involved in the launch of Amazon CodeCatalyst. Outside the work environment, Sorin explores international cinema, cooks Italian food, and watches Premier League.",
    image: Sorin,
    socials: [
      {
        id: 1,
        linkedIn_link: "#",
        image: <FaLinkedinIn className="linkedIn" />,
      },
      {
        id: 2,
        github_link: "#",
        image: <AiFillGithub className="github" />,
      },
    ],
  },
  {
    id: 4,
    name: "Olusanmi Hundogan",
    title: "Founder & CIO",
    about:
      "Olu is a passionate tech enthusiast with a business informatics and artificial intelligence background. He is an experienced developer possessing knowledge of a wide range of subfields within Computer Science and Machine Learning. Within Oxari, Olu is tasked with overseeing the development of the machine learning pipelines as well as other subsequent projects. Olu worked for a total of 6 years for Robert Bosch. He is not only a full-stack engineer but also very experienced with Deep Learning and NLP. When he is not coding, Olu goes bouldering, plays chess, and codes a little more.",
    image: Olu,
    socials: [
      {
        id: 1,
        linkedIn_link: "#",
        image: <FaLinkedinIn className="linkedIn" />,
      },
      {
        id: 2,
        github_link: "#",
        image: <AiFillGithub className="github" />,
      },
    ],
  },
  {
    id: 5,
    name: "Stefano Scola",
    title: "Software Developer",
    about:
      'Stefano is a Software Developer based in Italy. He studied Artificial Intelligence and Cognitive Science at Tilburg University. He is fascinated by Linguistics, Human Cognition, and the Ethical Challenges within AI, to name a few. The usual place to catch Stefano in a meeting is the train, as he often travels across Europe while working. After work, Stefano produces music, plays board games, and is a strong adept of "dolce far niente".',
    image: Stephano,
    socials: [
      {
        id: 1,
        linkedIn_link: "#",
        image: <FaLinkedinIn className="linkedIn" />,
      },
      {
        id: 2,
        github_link: "#",
        image: <AiFillGithub className="github" />,
      },
    ],
  },
  {
    id: 6,
    name: "Til Dietrich",
    title: "Environmental Economist & Data Scientist",
    about:
      "Til is currently involved in developing econometric models for scientific publications. He previously worked at the sustainability bank Triodos and graduated from Nova SBE with a M.Sc. in Economics, focusing on environmental and behavioural economics as well as econometrics. Being involved in both decision-making and methodology developments, Til plays a central role at Oxari. He is passionate about environmental issues, with a strong concern for social equity in the transition towards a more sustainable society. Til loves diving into the philosophy of human behaviour, cooking and surfing on the Portuguese coast, where he currently resides.",
    image: Til,
    socials: [
      {
        id: 1,
        linkedIn_link: "#",
        image: <FaLinkedinIn className="linkedIn" />,
      },
      {
        id: 2,
        github_link: "#",
        image: <AiFillGithub className="github" />,
      },
    ],
  },
  {
    id: 7,
    name: "Matson Ho",
    title: "Software Developer",
    about:
      "Matson is an aspiring full-stack developer. He graduated in Economics from the University of Groningen. He started coding during his university years and has been hooked ever since. In his spare time, he enjoys reading manga and water sports.",
    image: Matson,
    socials: [
      {
        id: 1,
        linkedIn_link: "#",
        image: <FaLinkedinIn className="linkedIn" />,
      },
      {
        id: 2,
        github_link: "#",
        image: <AiFillGithub className="github" />,
      },
    ],
  },
  {
    id: 8,
    name: "Julia Boers",
    title: "Software Developer Intern",
    about:
      "Julia is a master's student in Artificial Intelligence at the University of Groningen. She is mostly interested in the field of Explainable AI. She likes to play chess and other boardgames, go ice skating in winter and running in summer.",
    image: Julia,
    socials: [
      {
        id: 1,
        linkedIn_link: "#",
        image: <FaLinkedinIn className="linkedIn" />,
      },
    ],
  },

  {
    id: 9,
    name: "Zoe Tzifa-Kratira",
    title: "Software Developer Intern",
    about:
      "Zoe is a student of Artificial Intelligence in Groningen. She is interested in the fields of Deep Learning, Neuromorphic Computing and Ethics in AI, particularly algorithmic bias and responsible design. Outside of studying, she loves to play ultimate frisbee, tennis, and classical music, and to keep up with the latest in movies.",
    image: Zoe,
    socials: [],
  },
  {
    id: 10,
    name: "Nanda Vikas Konduru",
    title: "Software Developer Intern",
    about:
      "Nanda is a student of Data Science at University of Trier. He is interested in creating products by using Artificial Intelligence and Web Development. Outside of work, he is interested in travelling, playing outdoor games.",
    image: Nanda,
    socials: [
      {
        id: 1,
        linkedIn_link: "#",
        image: <FaLinkedinIn className="linkedIn" />,
      },
      {
        id: 2,
        github_link: "#",
        image: <AiFillGithub className="github" />,
      },
    ],
  },
];

export const Companies = [
  {
    id: 1,
    name: "Alexandria Real Estate Equities Inc",
    niche: "Real Estate",
    country: "United States",
    countryFlag: "",
  },
  {
    id: 2,
    name: "Coca-Cola Co",
    niche: "Consumer Staples",
    country: "United States",
    countryFlag: "",
  },
  {
    id: 3,
    name: "Mediaset SpA",
    niche: "Communication",
    country: "Italy",
    countryFlag: "",
  },
  {
    id: 4,
    name: "Sage Group PLC",
    niche: "Technology",
    country: "United Kingdom",
    countryFlag: "",
  },
  {
    id: 5,
    name: "Eni SpA",
    niche: "Energy",
    country: "Italy",
    countryFlag: "",
  },
  {
    id: 6,
    name: "1&1 Drillisch AG",
    niche: "Communication",
    country: "Germany",
    countryFlag: "",
  },
  {
    id: 7,
    name: "Apple Inc",
    niche: "Technology",
    country: "United States",
    countryFlag: "",
  },
  {
    id: 8,
    name: "Bloom Energy Corporation Class A",
    niche: "Industrials",
    country: "United States",
    countryFlag: "",
  },
  {
    id: 9,
    name: "Coca-Cola European Partners PLC",
    niche: "Consumer Staples",
    country: "United Kingdom",
    countryFlag: "",
  },
  {
    id: 10,
    name: "Microsoft Corp",
    niche: "Technology",
    country: "United States",
    countryFlag: "",
  },
];

export const Methods = [
  {
    id: 1,
    title: "Benchmarks",
    link: "",
    description:
      "We used sMAPE(Symmetric mean absolute percentage error), which is also frequently used in competitions, instead of MAPE(Mean absolute percentage error) because MAPE puts a heavier penalty on negative errors. sMAPE is an error, so the lower the resulting error, the better the model. We also reported the adjusted R2 score for each model. Contrary to sMAPE, the higher the adjusted R2, the better as more variance is explained by the included variables. In the case of the regression on revenue, we reported the R2 score as just one independent variable was used.",
    image: Benchmark,
  },
  {
    id: 2,
    title: "Scope Analysis",
    link: "",
    description:
      "We also analysed the interaction between the scopes in the emission dataset we had in our hands. The presented correlation matrix shows the correlation between the 3 scopes before any data preprocessing was applied. As the correlation values always lay between -1 and 1, we can notice the existence of a slightly positive correlation between the scopes, especially looking at the interaction of scope 1 and scope 2.",
    image: Scope,
  },
];
